var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "projects-card-res" },
    [
      _c("div", { staticClass: "p-4" }, [
        _c("div", { staticClass: "flex justify-between items-center" }, [
          _c(
            "div",
            { staticClass: "project-name focus:!outline-none" },
            [
              _c(
                "RouterLink",
                {
                  staticClass:
                    "block hover:text-primary cursor-pointer focus!:outline-none",
                  attrs: {
                    to: {
                      name: _vm.projectDetailsRoute,
                      params: { id: _vm.client.id },
                    },
                  },
                },
                [
                  _c("div", [
                    _c("p", { staticClass: "hover:text-primary-500 mb-2" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            this.client.client_name
                              ? this.client.client_name
                              : "n/a"
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("p", { staticClass: "visitBubble" }, [
            _vm._v(
              " " +
                _vm._s(_vm.client.project_activities.length) +
                " " +
                _vm._s(
                  _vm.client.project_activities.length === 1
                    ? "visit"
                    : "visits"
                )
            ),
          ]),
        ]),
        _c(
          "p",
          { staticClass: "font-outfit font-medium text-sm text-storm-gray" },
          [
            _vm._v(
              " " +
                _vm._s(_vm.age(this.client.dob)) +
                " | " +
                _vm._s(this.client.gender || "n/a") +
                " "
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "flex flex-col gap-2 mt-2 px-2 py-4 rounded",
            class: _vm.getStyleClass(_vm.nearestVisits),
          },
          [
            _c(
              "p",
              {
                staticClass: "font-outfit font-medium text-xs text-storm-gray",
              },
              [_vm._v(" Visit information ")]
            ),
            _c("div", { staticClass: "flex flex-col gap-1" }, [
              _c(
                "div",
                { staticClass: "flex flex-row gap-2 items-start" },
                [
                  _c("LocationIcon", {
                    staticClass: "w-4 h-4 mt-1.5 minWidthFitContent",
                  }),
                  _vm.nearestVisits &&
                  _vm.nearestVisits.virtual &&
                  _vm.nearestVisits.virtual_meeting_link
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "text-sky-blue text-sm font-normal font-outfit locationWidth inline-flex items-center gap-1",
                          attrs: {
                            href: _vm.nearestVisits.virtual_meeting_link,
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            },
                            [
                              _c("rect", {
                                attrs: {
                                  x: "2",
                                  y: "7",
                                  width: "20",
                                  height: "15",
                                  rx: "2",
                                  ry: "2",
                                },
                              }),
                              _c("polyline", {
                                attrs: { points: "22,7 12,13 2,7" },
                              }),
                            ]
                          ),
                          _vm._v(" Join Virtual Meeting "),
                        ]
                      )
                    : this.client.address
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "text-sky-blue text-sm font-normal font-outfit locationWidth",
                          attrs: {
                            href: `https://www.google.com/maps/place/${this.client.address}`,
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(this.client.address))]
                      )
                    : _c(
                        "p",
                        {
                          staticClass:
                            "text-sky-blue text-sm font-normal font-outfit minHeight",
                        },
                        [_vm._v(" n/a ")]
                      ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex flex-row gap-2 items-start" },
                [
                  _c("HouseIcon", {
                    staticClass: "w-3.5 h-3.5 mt-1.5 minWidthFitContent",
                  }),
                  _c(
                    "p",
                    {
                      staticClass:
                        "font-outfit font-normal text-sm text-dark-gray",
                    },
                    [_vm._v(" Work type: " + _vm._s(_vm.typeOfWork) + " ")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "flex flex-col gap-1 w-full" }, [
              _c("span", { staticClass: "team-teams" }, [_vm._v("Manager")]),
              _vm.client.manager
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-row gap-1 justify-between items-center",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "manager-chip flex flex-row items-center",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "bg-primary-500 rounded-full flex items-center text-xs flex-shrink-0 justify-center text-white manager-image",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.client.manager.user?.given_name?.toUpperCase()[0]
                                    ) +
                                    _vm._s(
                                      _vm.client.manager.user?.family_name?.toUpperCase()[0]
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm._v(" " + _vm._s(_vm.projectManager) + " "),
                          ]
                        ),
                        _c(
                          "ColorIconContainer",
                          {
                            staticClass:
                              "flex justify-center items-center h-6 w-6",
                            attrs: { iconStyle: "" },
                            on: { click: _vm.message },
                          },
                          [_c("MessageIcon")],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _c("p", [_vm._v("n/a")]),
            ]),
          ]
        ),
        _vm.nearestVisits.accepted === null
          ? _c(
              "div",
              { staticClass: "flex flex-col gap-2 mt-5" },
              [
                _c("UIButton", {
                  staticClass: "font-outfit",
                  attrs: {
                    buttonText: "Accept",
                    fullWidth: true,
                    variant: "black",
                    size: "sm",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.updateVisitsAcceptModal(true)
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "icon",
                        fn: function () {
                          return [_c("CheckIcon", { staticClass: "w-4 h-4" })]
                        },
                        proxy: true,
                      },
                      {
                        key: "hover-icon",
                        fn: function () {
                          return [
                            _c("CheckMarkBlack", { staticClass: "w-6 h-6" }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2448753915
                  ),
                }),
                _c("UIButton", {
                  staticClass: "font-outfit",
                  attrs: {
                    buttonText: "Decline",
                    variant: "outline-black",
                    fullWidth: true,
                    size: "sm",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.updateVisitsDeclineModal(true)
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "icon",
                        fn: function () {
                          return [_c("XIcon", { staticClass: "w-4 h-4" })]
                        },
                        proxy: true,
                      },
                      {
                        key: "hover-icon",
                        fn: function () {
                          return [_c("XIcon", { staticClass: "w-4 h-4" })]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1155485538
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm.toggleVisitsAcceptModal
        ? _c("ClientVisitsModal", {
            attrs: {
              client: _vm.client,
              currentMode: _vm.currentMode,
              currentUser: _vm.currentUser,
            },
            on: {
              onSubmit: _vm.onSubmitVisits,
              close: function ($event) {
                return _vm.updateVisitsAcceptModal(false)
              },
            },
          })
        : _vm._e(),
      _vm.toggleVisitsConfirmModal
        ? _c("ClientVisitsConfirmModal", {
            attrs: {
              selectedVisits: _vm.selectedVisits,
              currentMode: _vm.currentMode,
              currentUser: _vm.currentUser,
            },
            on: {
              close: function ($event) {
                return _vm.updateVisitsConfirmModal(false)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }